import { FC } from 'react'

import { MapProviderType } from '@constants'

import { Map2GISProvider } from '../providers/Map2GIS'
import { MapLibreProvider } from '../providers/MapLibre'
import { MapYandexProvider } from '../providers/MapYandex'

import { MapProviderProps } from './types'

/**
 * Фабрика провайдеров карт
 */
export const getMapProviderComponent = (providerType: MapProviderType): FC<MapProviderProps> => {
  switch (providerType) {
    case MapProviderType.MAP_2GIS:
      return Map2GISProvider

    case MapProviderType.YANDEX:
      return MapYandexProvider

    case MapProviderType.MAPLIBRE:
      return MapLibreProvider

    default:
      throw new Error(`Unknown map provider: ${providerType}`)
  }
}
